import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { type GetNextApprovalStepData } from '../business-logic/types/GetNextApprovalStepData'
import { getAutomationOrderDraftUseCase } from '../business-logic/use-cases/GetAutomationOrderDraftUseCase'
import { getOrderDraftUseCase } from '../business-logic/use-cases/GetOrderDraftUseCase'
import { getPreferredOrderRequestFlowUseCase } from '../business-logic/use-cases/GetPreferredOrderRequestFlowUseCase'
import { orderDraftRepository } from '../data-access/repositories/OrderDraftRepository'

const base = ['order-draft']

export const currentOrderDraftQueryKey = buildQueryKey([...base, 'current'])

export const saveOrderDraftMutationKey = buildQueryKey([
  ...base,
  'save-details',
])

export const orderDraftQueryConfig = {
  getOrderDraft: ({
    userId,
    userPrimaryCategoryId,
    userSecondaryCategoryId,
  }: {
    userId: number
    userPrimaryCategoryId: Nullable<number>
    userSecondaryCategoryId: Nullable<number>
  }) => ({
    queryKey: currentOrderDraftQueryKey,
    queryFn: () =>
      getOrderDraftUseCase({
        userId,
        userPrimaryCategoryId,
        userSecondaryCategoryId,
      }),
  }),
  getOrderDraftComputedValues: () => ({
    queryKey: buildQueryKey([...base, 'computed-values']),
    queryFn: () => orderDraftRepository.getOrderDraftComputedValues(),
  }),
  getAutomationOrderDraft: () => ({
    queryKey: buildQueryKey([...base, 'automation', 'current']),
    queryFn: () => getAutomationOrderDraftUseCase(),
  }),
  getPreferredRequestFlow: (userId: number) => ({
    queryKey: buildQueryKey([...base, 'preferred-request-flow', userId]),
    queryFn: () => getPreferredOrderRequestFlowUseCase(userId),
    enabled: !!userId,
  }),
  getInitialApproverOptions: (data: GetNextApprovalStepData) => ({
    queryKey: buildQueryKey([...base, 'initial-approver-options', data]),
    queryFn: () => orderDraftRepository.getInitialApproverOptions(data),
  }),
}
